export const getClassName = className => {
  const classNames = "material-icons";

  if (!!className) return classNames + " " + className;

  return classNames;
};
